import * as _ from "lodash";

export function getValidationErrors(xs) {
  let out = {};
  for (let x of xs) {
    const pth = x.dataPath.replace(".body.", "").split(".");
    _.set(out, pth, x.message);
  }
  return out;
}
